'use client';

import { ToastContainer } from 'react-toastify';

export function ToastProvider() {
  return <ToastContainer style={{ marginTop: 65, zIndex: 999999 }} position="top-right" newestOnTop theme="colored" />;
}
